export const TEXT_FIELD = 'text_field'
export const COMPANY_FIELD = 'company_field'
export const TEAM_FIELD = 'team_field'
export const DATE_FIELD = 'date_field'
export const SELECT_FIELD = 'select_field'
export const MONEY_FIELD = 'money_field'
export const BOOL_FIELD = 'bool_field'
export const CUSTOMER_NAME_FIELD = 'customer_name_field'
export const USER_FLOW_BASE = 'user_flow_base'
export const NO_CONTENT = 'no_content'